/**
 * AI 가드레일 API (docs/features/21-ai-guardrail.md). AI 와 무관하게 열려 있다 — 내보내기 검사는 AI 제외 빌드에서도 쓴다.
 * 이 라우트들은 가드레일 오류(428·409)를 내지 않는다 — 관문(guardrailGate)이 이것들을 부르므로 내면 무한히 돈다.
 */
import axios from 'axios';

const ROOT = `${process.env.REACT_APP_API_BASE_URL || '/sql-developer'}/guardrail`;

export const getPolicy = async () => (await axios.get(`${ROOT}/policy`)).data;
export const savePolicy = async (rules) => (await axios.put(`${ROOT}/policy`, { rules })).data;
export const resetPolicy = async () => (await axios.post(`${ROOT}/policy/reset`, {})).data;
export const acknowledge = async () => (await axios.post(`${ROOT}/ack`, {})).data;
export const getPending = async () => (await axios.get(`${ROOT}/pending`)).data;
export const saveDecisions = async (scope, decisions) => (await axios.post(`${ROOT}/decisions`, { scope, decisions })).data;
// 보내기 전 검사의 결정 — 그 요청 한 번만(2026-10-20)
export const saveReview = async (scope, decisions) => (await axios.post(`${ROOT}/review`, { scope, decisions })).data;
export const scanText = async (text, rules) => (await axios.post(`${ROOT}/scan`, { text, ...(rules ? { rules } : {}) })).data;
export const redactText = async (text, mode) => (await axios.post(`${ROOT}/redact`, { text, mode })).data;
/** 연결의 지금 스키마에서 테이블·뷰·스키마 이름 후보 — 규칙에 넣는 것은 화면에서 사람이 고른다 */
export const suggestNames = async (connectionId) => (await axios.post(`${ROOT}/suggest-names`, { connectionId })).data;
export const listTokens = async () => (await axios.get(`${ROOT}/tokens`)).data;
export const clearTokens = async () => (await axios.delete(`${ROOT}/tokens`)).data;
